import { faFile } from "@fortawesome/pro-regular-svg-icons";

import { EditorAccordionItem as AccordionItem } from "src/base-components/EditorAccordionItem";
import { Pill } from "src/base-components/Pill";
import { FileCard } from "src/cases/caseView/FileCard";
import { GetFileEnvFilesFileIdGetEnvEnum } from "src/clients/files";

export type FileCategoryData = {
  id: string;
  display_name: string;
  description?: string;
  category_key: string;
  file_ids: string[];
};

type FileCategoryProps = {
  category: FileCategoryData;
  env: GetFileEnvFilesFileIdGetEnvEnum;
  fileCategories: FileCategoryData[];
  onDeleteFile: (fileId: string, fileName: string, categoryKey: string) => void;
  onMoveFile: (
    fileId: string,
    fileName: string,
    fromCategory: string,
    toCategory: string,
  ) => void;
  canEdit: boolean;
  canDelete: boolean;
  newlyUploadedFileIds?: string[];
};

export const FileCategory: React.FC<FileCategoryProps> = ({
  category,
  env,
  fileCategories,
  onDeleteFile,
  onMoveFile,
  canEdit,
  canDelete,
  newlyUploadedFileIds,
}) => {
  const fileCount = category.file_ids.length;
  const hasFiles = fileCount > 0;

  return (
    <AccordionItem
      className="p-4"
      disabled={!hasFiles}
      headerClassName="radix-state-open:border-b"
      title={
        <div className="flex items-center gap-2">
          <span>{category.display_name}</span>
          <Pill size="sm" variant="indigo-light">
            <Pill.Icon icon={faFile} />
            <Pill.Text>{fileCount}</Pill.Text>
          </Pill>
        </div>
      }
      value={category.category_key}
    >
      <div className="flex flex-col gap-3">
        {category.file_ids.map((fileId) => (
          <FileCard
            key={fileId}
            canDelete={canDelete}
            canEdit={canEdit}
            categoryKey={category.category_key}
            env={env}
            fileCategories={fileCategories}
            fileId={fileId}
            isNewlyUploaded={newlyUploadedFileIds?.includes(fileId)}
            onDeleteFile={onDeleteFile}
            onMoveFile={onMoveFile}
          />
        ))}
      </div>
    </AccordionItem>
  );
};
